import { render, staticRenderFns } from "./Breadcrumbs.component.vue?vue&type=template&id=4b3a9862&scoped=true"
import script from "./Breadcrumbs.component.vue?vue&type=script&lang=js"
export * from "./Breadcrumbs.component.vue?vue&type=script&lang=js"
import style0 from "./Breadcrumbs.component.vue?vue&type=style&index=0&id=4b3a9862&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3a9862",
  null
  
)

export default component.exports